import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

//
import { styled } from "@mui/material/styles";

import Uploadfiles from "./UploadFiles";
import ViewFiles from "./ViewFiles";

//Apis
import driverApi from "Services/Driver";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Documents = ({ driverId , setsubmitButton , setSkipButton }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  setsubmitButton(true);
  setSkipButton(true);
  const [row, setRow] = useState([]);

  const [uploadFilesModal, setUploadFilesModal] = useState(false);
  const [viewFilesModal, setViewFilesModal] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [documentData, setDocumentData] = useState([]);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsInitialData, setDocumentsInitialData] = useState([]);
  
  const handleOpenUploadFilesModal = (row) => {
    setDocumentId(row?.documentId);
    setDocumentData(row);
    setUploadFilesModal(true);
  };

  const handleCloseUploadFilesModal = () => {
    getDriverDocuments();
    setUploadFilesModal(false);
  };

  const handleCloseViewFilesModal = () => {
    getDriverDocuments();
    setViewFilesModal(false);
  };

  // View modal
  const handleOpenViewFilesModal = (row) => {
    setDocumentId(row?.documentId);
    setDocumentData(row);
    setViewFilesModal(true);
  };

  //Get documents

  const getDriverDocuments = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
   setDriverDocumentsData(res?.data?.data?.driverDocuments);
          setDocumentsInitialData([
            {
            id: 1,
            sno: "1",
            documentId: 0,
            documentType: "Proof of address",
            documentTypeAlias: "PROOF OF ADDRESS",
            file: "",
            status: "No document found",
          }           
          ]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };

    if (validation) {
      driverApi
        .getDriverDocumentsByDriverId(driverId)
        .then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    getDriverDocuments();
  }, []);
  // Handle driver delete document

  const handleDeleteDocument = (row) => {

    var result = window.confirm("Do you want to Delete?");
    if (result) {
      dispatch(showLoader("Loading please wait..."));
   
      let data = {
        document_id:row?.documentId,
        user_id:driverId,
      }
    
      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          dispatch(
            showSnackbar({
              message: "Document deleted successfully",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            })
          );
        }
        getDriverDocuments();
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        showSnackbar({
          message: "Failed to delete the document",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        });
      };
  
      driverApi.deleteDriverDocument({ ...data }).then(onSuccess, onFailure);
    }
  };


  useEffect(() => {
    const combinedArray = documentsInitialData.map((item1) => {
      const matchingDocument = driverDocumentsData.find((item2) => {
        return item1.documentTypeAlias === item2.documentType;
      });

      const documentId = matchingDocument ? matchingDocument._id : 0;
      const documentPath = matchingDocument
        ? matchingDocument.documentPath ? matchingDocument.documentPath : ""
        : "";
      const status = matchingDocument
        ? matchingDocument.documentPath ? matchingDocument.status :"NO DOCUMENT"
        : "NO DOCUMENT";
       
      return {
        ...item1,
        documentId,
        file: documentPath,
        status,
      };
    });
    setRow(combinedArray);
  }, [driverDocumentsData]);

  const dataRows = _.map(row || [], (data, index) => ({
    id: index + 1,
    sno: index + 1,
    documentId: data?.documentId,
    documentType: data?.documentType,
    documentTypeAlias: data?.documentTypeAlias,
    file: data?.file,
    status: data?.status,
  }));

// useEffect(() => {
//   const allApproved = _.every(row, (doc) => doc?.status === "APPROVED");

//   setsubmitButton(allApproved);
//   setSkipButton(allApproved);
// }, [row]);


  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      minWidth: 180,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "documentType",
      headerName: "Document Type",
      minWidth: 200,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">
                {params?.row?.documentType}
              </Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 320,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.actionBtnWrapper}>
            {params?.row?.file == "" && (
              <section className={classes.uploadButton}>
                <Button
                  variant="contained"
                  style={{ fontSize: "13px", borderRadius: "8px" }}
                  onClick={() => handleOpenUploadFilesModal(params?.row)}
                >
                  Upload
                </Button>
              </section>
            )}
              {params?.row?.file != "" && (
                <>
                  <section className={classes.viewButton}>
                    <Button
                      variant="outlined"
                      style={{ fontSize: "13px", borderRadius: "8px" }}
                      onClick={() => handleOpenViewFilesModal(params?.row)}
                    >
                      View
                    </Button>
                  </section>

                  <section className={classes.deleteButton}>
                    <Button
                      variant="contained"
                      style={{ fontSize: "13px", borderRadius: "8px" }}
                      onClick={() => handleDeleteDocument(params?.row)}
                    >
                      Delete
                    </Button>
                  </section>
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              rows={dataRows}
              columns={columns}
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
            />
          </section>
        </Grid>
        <Uploadfiles
          openDialog={uploadFilesModal}
          handleClose={handleCloseUploadFilesModal}
          driverId={driverId}
          documentId={documentId}
          documentData={documentData}
        ></Uploadfiles>
        <ViewFiles
          openDialog={viewFilesModal}
          handleClose={handleCloseViewFilesModal}
          driverId={driverId}
          documentId={documentId}
          documentData={documentData}
        ></ViewFiles>
      </Grid>
    </>
  );
};

export default Documents;
